import { getSettingAddBrowserTabIdHeader } from "@faire/retailer-visitor-shared/settings/getSettingAddBrowserTabIdHeader";
import { RequestOptions } from "@faire/web-api--source/types";
import { getBrowserTabId } from "@faire/web/common/globals/getBrowserId";

const HEADER_BROWSER_TAB_ID = "X-FAIRE-BROWSER-TAB-ID";

/**
 * Interceptor that adds the browser tab ID as a header to outgoing requests,
 * controlled by a feature setting.
 * This helps with tracking requests across browser tabs/sessions.
 *
 * @param request - The request to modify
 * @returns The modified request with the browser tab ID header if the setting is enabled
 */
export const browserTabIdInterceptor = (
  config: RequestOptions
): RequestOptions => {
  if (!getSettingAddBrowserTabIdHeader()) {
    return config;
  }

  const browserTabId = getBrowserTabId();
  config.headers.set(HEADER_BROWSER_TAB_ID, browserTabId);
  return config;
};
